'use strict';

module.exports = {
  CREATE_AUTO_RELOAD: 'create-auto-reload',
  UPDATE_AUTO_RELOAD: 'update-auto-reload',
  DISABLE_AUTO_RELOAD: 'disable-auto-reload',
  TRANSFER_CARD_BALANCE: 'transfer-card-balance',
};
